<app-version-card [version]="currentVersion" [versionType]="versionType"></app-version-card>
